<template>
  <v-form
      v-if="settings"
      v-model="formIsValid"
      ref="settingsForm"
  >
    <v-row>
      <v-col
          cols="12"
          sm="4"
      >
        <v-select
            v-model="settings.widget.type"
            item-value="id"
            item-text="title"
            label="Тип виджета"
            :items="widgetTypeArr"
        >
        </v-select>
      </v-col>
      <v-col
          cols="12"
          sm="4"
      >
        <v-text-field
            v-model="settings.widget.title"
            label="Название в ВК"
            :rules="rules.widgetTitle"
        ></v-text-field>
      </v-col>
      <v-col
          cols="12"
          sm="4"
      >
        <v-text-field
            v-model="settings.widget.buttonTitle"
            label="Название кнопки"
            counter="50"
            :rules="rules.widgetButtonTitle"
        ></v-text-field>
      </v-col>
      <v-col
          cols="12"
          sm="6"
      >
        <v-checkbox
            v-model="settings.widget.showDateStop"
            class="mt-0"
            label="Добавить дату стопа"
        ></v-checkbox>
      </v-col>

      <v-col
          cols="12"
          sm="6"
      >
        <v-checkbox
            v-model="settings.widget.showSumMinimal"
            class="mt-0"
            label="Добавить минимальную сумму"
        ></v-checkbox>
      </v-col>
    </v-row>

    <div>
      <v-row
          align="center"
          justify="start"
      >
        <v-col
            class="pb-0"
            cols="12"
        >
          <v-combobox
              v-model="settings.widget.buyouts"
              append-icon=""
              chips
              clearable
              placeholder="Поиск закупки..."
              label="Выберите закупки"
              multiple
              small-chips
              :loading="buyoutsLoading"
              :rules="rules.widgetBuyouts"
              :search-input.sync="query"
              @change="widgetBuyoutsChange"
              @update:search-input="delayedGetBuyouts"
          >
            <template v-slot:selection="{ attrs, item, index, selected }">
              <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  pill
                  small
                  @click:close="widgetRemoveBuyout(index)"
              >
                <v-avatar left>
                  <v-img :src="item.preview"></v-img>
                </v-avatar>
                {{ item.title }}
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <v-list>
        <v-row dense no-gutters>
          <v-col
              v-if="!buyoutsLoading && buyouts && !buyouts.length"
              cols="12"
          >
            <Info
                message="Закупки не найдены"
                :sub-message="query ? 'Попробуйте изменить условия поиска' : 'Возможно вы еще не создавали закупки в органайзере'"
            ></Info>
          </v-col>
          <v-col
              v-for="buyout in buyouts"
              sm="4"
              cols="6"
              :key="buyout.id"
          >
            <v-list-item
                :disabled="buyoutsLoading"
                @click="widgetAddBuyout(buyout)"
            >
              <v-list-item-avatar>
                <v-img :src="buyout.preview"></v-img>
              </v-list-item-avatar>
              <v-list-item-title v-text="buyout.title"></v-list-item-title>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>
    </div>

    <SourceSettingsWidgetUrls
        v-if="settings.widget.buyouts.length > 0"
        :settings="settings.widget"
        :urls="urlsOverride"
        @clear="overrideUrlsClear"
        @update="overrideUrlsUpdate"
        @validate="overrideUrlsValidate"
    ></SourceSettingsWidgetUrls>

    <Info
        v-if="error"
        :error="error"
    ></Info>

    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn
            class="mx-1"
            color="red"
            text
            type="button"
            :disabled="process"
            @click="$router.go(-1)"
        >
          Назад
        </v-btn>
        <v-btn
            class="mx-1"
            color="primary"
            dark
            type="button"
            :disabled="process"
            :loading="process"
            @click="submit"
        >
          <span v-if="settings.widget.installed">Обновить виджет</span>
          <span v-if="!settings.widget.installed">Установить виджет</span>
        </v-btn>
        <v-btn
            v-if="isVkAppDesktop && settings.widget.installed"
            class="mx-1"
            color="red"
            dark
            :disabled="processDelete"
            :loading="processDelete"
            @click="widgetDelete"
        >
          Удалить виджет
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  <div v-else>
    <v-row>
      <v-col
          cols="12"
          sm="4"
      >
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
      <v-col
          cols="12"
          sm="4"
      >
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
      <v-col
          cols="12"
          sm="4"
      >
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
      <v-col
          cols="12"
          sm="6"
      >
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
      <v-col
          cols="12"
          sm="6"
      >
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
      <v-col
          cols="12"
      >
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {getWidgetPreview, tokenGet} from '@/services/vkApi'
import Info from '@/components/Info'
import SourceSettingsWidgetUrls from '@/components/SourceSettingsWidgetUrls'
import {getIsVkAppDesktop, getSourceId} from '@/composables/context'
import {types} from '@/constants'
const buyoutsLimit = 6
let _timer

export default {
  name: 'SourceSettingsWidget',
  components: {Info, SourceSettingsWidgetUrls},
  computed: {
    isVkAppDesktop: getIsVkAppDesktop,
    settingsIsValid () {
      return this.formIsValid && this.overrideUrlsIsValid
    },
    sourceId: getSourceId
  },
  created () {
    this.$client.get(`${this.$API.SOURCES.SETTINGS.LIST}?sourceId=${this.sourceId}`)
      .then(this.initSettings)
      .catch(err => {
        if (err.code === 404){
          this.initSettings()
        } else {
          this.err = err.message
        }
    })
  },
  data () {
    return {
      buyouts: null,
      buyoutsLoading: false,
      error: null,
      query: '',
      formIsValid: false,
      overrideUrlsIsValid: true,
      process: false,
      processDelete: false,
      rules: {
        widgetBuyouts: [
          v => v && v.length > 0 || 'Необходимо выбрать закупки'
        ],
        widgetButtonTitle: [
          v => !!v || 'Необходимо ввести название кнопки',
          v => !v || v.length <= 50 || 'Не более 50 символов'
        ],
        widgetTitle: [
          v => !!v || 'Необходимо ввести название'
        ]
      },
      settings: null,
      urlsOverride: [],
      widgetTypeArr: Object.values(types.widget)
    }
  },
  methods: {
    delayedGetBuyouts () {
      if (this.query === null) {
        return
      }
      if (_timer) {
        clearTimeout(_timer)
      }
      _timer = setTimeout(() => this.getBuyouts(), 400)
    },
    getBuyouts (isFirst = false) {
      this.buyoutsLoading = true
      this._filterSettingsWidgetBuyouts()
      this._fillUrlsOverride(isFirst)
      this.$client.post(this.$API.BUYOUTS.ADMIN_LIST, {
        sourceId: this.sourceId,
        limit: buyoutsLimit,
        offset: 0,
        query: this.query || '',
        idsExcluded: this.settings.widget.buyouts.map(item => item.id),
        needAlbums: true
      })
        .then(rs => {
          this.buyouts = rs.items
        })
        .finally(() => this.buyoutsLoading = false)
    },
    initSettings (rs) {
      if (rs){
        this.settings = rs
      } else {
        this.settings = {}
      }
      if (!this.settings.widget){
        this.settings.widget = {
          type: this.widgetTypeArr[0].id,
          buyouts: []
        }
      }
      if (!this.settings.widget.override) {
        this.settings.widget.override = {}
      }
      this.getBuyouts(true)
    },
    overrideUrlsClear () {
      delete this.settings.widget.override.urls
      this.settings = JSON.parse(JSON.stringify(this.settings))
    },
    overrideUrlsUpdate (urls) {
      const map = {}
      urls.forEach(elm => map[elm.id] = elm.url)
      this.settings.widget.override.urls = map
    },
    overrideUrlsValidate (valid) {
      this.overrideUrlsIsValid = valid
    },
    widgetAddBuyout (buyout) {
      this.query = ''
      this.settings.widget.buyouts.push(buyout)
      this.getBuyouts()
    },
    widgetBuyoutsChange () {
      this.getBuyouts()
    },
    widgetDelete () {
      this.processDelete = true
      this.error = null
      getWidgetPreview('compact_list', 'return false;')
        .then(() => {
          this.$client.post(`${this.$API.SOURCES.WIDGET.DELETE}`, {sourceId: this.sourceId})
              .then(this.settings.widget.installed = false)
              .finally(() => this.processDelete = false)
        })
        .catch((err) => {
          this.widgetProcessVKError(err)
          this.processDelete = false
        })
    },
    widgetGetPreview(){
      this.$client.get(`${this.$API.SOURCES.WIDGET.PREVIEW}?sourceId=${this.sourceId}`)
          .then(this.widgetShowPreview)
          .catch(err => {
            if (err.code === 403){
              tokenGet()
            } else {
              this.error = err
            }
          })
          .finally(() => this.process = false)
    },
    widgetProcessVKError (err) {
      this.error = {
        code: err.error_data.error_code,
        message: err.error_data.error_reason
      }
    },
    widgetRemoveBuyout (idx) {
      this.settings.widget.buyouts.splice(idx, 1)
      this.getBuyouts()
    },
    widgetShowPreview (rs) {
      getWidgetPreview('compact_list', rs.code)
        .then(() => {
          this.$client.post(
            `${this.$API.SOURCES.WIDGET.INSTALL}`,
            {sourceId: this.sourceId})
            .then(() => this.settings.widget.installed = true)
      })
        .catch(this.widgetProcessVKError)
    },
    submit () {
      if (!this.settingsIsValid) {
        return
      }
      this.error = null
      this.process = true
      const data = JSON.parse(JSON.stringify(this.settings))
      data.widget.buyoutsIds = this.settings.widget.buyouts.map(item => item.id)
      delete data.widget.buyouts

      this.$client.post(this.$API.SOURCES.SETTINGS.SET, {
        sourceId: this.sourceId,
        settings: data
      })
        .then(this.widgetGetPreview)
        .catch(err => {
          this.error = err
        })
    },
    _fillUrlsOverride (isFirst) {
      if (isFirst && this.settings.widget.override.urls) { // disabled
        this.urlsOverride = this.settings.widget.buyouts.map(item => {
          const overrided = this.settings.widget.override.urls[item.id]
          return {id: item.id, title: item.title, url: overrided || item.albums[0].url}
        })
      } else {
        this.urlsOverride = this.settings.widget.buyouts.map(item => {
          return {id: item.id, title: item.title, url: item.albums[0].url}
        })
      }
    },
    _filterSettingsWidgetBuyouts () {
      this.settings.widget.buyouts = this.settings.widget.buyouts.filter(e => typeof e !== 'string')
    }
  }
}
</script>

<style scoped>

</style>